(function () {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const header = qs('[data-header]');
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('is-solid', window.scrollY > 16);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const toggle = qs('[data-menu-toggle]');
  if (toggle && header) {
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    qsa('[data-mobile-nav] a').forEach((a) =>
      a.addEventListener('click', () => {
        header.classList.remove('is-open');
        document.body.style.overflow = '';
      })
    );
  }

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const countEls = qsa('[data-cart-count]');
  const setCount = (n) => countEls.forEach((el) => {
    el.textContent = n;
    el.hidden = n < 1;
  });

  const drawer = qs('[data-cart-drawer]');
  const drawerBody = qs('[data-cart-body]');
  const drawerTotal = qs('[data-cart-total]');

  const renderDrawer = (cart) => {
    setCount(cart.item_count);
    if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
    if (!drawerBody) return;
    if (!cart.items.length) {
      drawerBody.innerHTML = '<p class="muted">Your kitchen cart is empty.</p>';
      return;
    }
    drawerBody.innerHTML = cart.items
      .map(
        (item) => `
        <div class="cart-row" data-key="${item.key}">
          <img src="${item.image || ''}" alt="">
          <div>
            <strong>${item.product_title}</strong>
            <div class="muted">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div class="qty" style="margin-top:.6rem">
              <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <input value="${item.quantity}" readonly>
              <button type="button" data-qty-change="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
          <div>${money(item.final_line_price)}</div>
        </div>`
      )
      .join('');
  };

  const refreshCart = () =>
    fetch('/cart.js')
      .then((r) => r.json())
      .then(renderDrawer)
      .catch(() => {});

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    refreshCart();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  };

  qsa('[data-open-cart]').forEach((el) => el.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  }));
  qs('[data-close-cart]')?.addEventListener('click', closeDrawer);
  qs('[data-cart-veil]')?.addEventListener('click', closeDrawer);

  drawerBody?.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.qtyChange, quantity: Number(btn.dataset.qty) }),
    })
      .then((r) => r.json())
      .then(renderDrawer);
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then((r) => {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(() => openDrawer())
      .catch(() => {
        window.location.href = '/cart';
      });
  });

  const variantSelects = qsa('[data-variant-selects]');
  variantSelects.forEach((root) => {
    const json = qs('[data-variant-json]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = qs('[name="id"]', root);
    const priceEl = qs('[data-product-price]');
    const btn = qs('[data-add-btn]', root.closest('form') || document);

    const current = () => {
      const opts = qsa('[data-option]', root).map((s) => s.value);
      return variants.find((v) => v.options.every((o, i) => o === opts[i]));
    };
    const sync = () => {
      const v = current();
      if (!v || !idInput) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.addLabel || 'Add to cart' : btn.dataset.soldLabel || 'Sold out';
      }
    };
    qsa('[data-option]', root).forEach((s) => s.addEventListener('change', sync));
    sync();
  });

  refreshCart();
})();
